export enum NotificationPreferenceTypes {
    NONE = 'NONE',
    ALL = 'ALL',
    CREATED_BY_ME = 'CREATED_BY_ME'
}
